import Features from '../Features';

function VRPage() {
    return (
      <div className="App">
       <Features/>
      </div>
    );
  }
  
  export default VRPage;